import Dropdown from "@/components/Dropdown";
import PropTypes from "prop-types";

const NetworkDropdown = ({
	selectedNetwork,
	setSelectedNetwork,
	availableNetworks,
}) => {
	return (
		<div className="etr__record-details__section__content__grid__item etr__record-details__section__content__grid__item-height">
			<label htmlFor="etr-dropdown" className="etr__record-details__dropdown__label">
				* Network Option
			</label>
			<Dropdown
				placeholder="Select Option"
				style={{
					width: "100%",
					display: "flex",
					flexDirection: "column",
					gap: "8px",
				}}
				value={availableNetworks?.find((option) => option?.networkId === selectedNetwork?.networkId)?.networkName}
				id="etr-dropdown"
			>
				{availableNetworks?.length > 0 && availableNetworks?.map((networkItem, index) => (
					<Dropdown.Item
						key={networkItem.networkId}
						onClick={() => setSelectedNetwork(networkItem)}
					>
						<div className={selectedNetwork?.networkId === networkItem.networkId ? "etr__record-details__address__list__item-active" : "etr__record-details__address__list__item"}>
							<span className="etr__record-details__span">
								{networkItem.networkName}
							</span>
						</div>
					</Dropdown.Item>
				))}
			</Dropdown>
		</div>
	);
};

NetworkDropdown.propTypes = {
	selectedNetwork: PropTypes.string,
	setSelectedNetwork: PropTypes.func,
	availableNetworks: PropTypes.array,
};

export default NetworkDropdown;
